export default function PageHeader({ title, subtitle, action }) {
  return (
    <div className="border-b border-neutral-200 dark:border-neutral-800 bg-white dark:bg-neutral-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-10 flex items-end justify-between gap-6">
        <div>
          <h1 className="font-display font-black tracking-tighter text-4xl sm:text-5xl text-neutral-900 dark:text-neutral-50">{title}</h1>
          {subtitle && <p className="mt-3 text-sm sm:text-base text-neutral-500 dark:text-neutral-400 max-w-2xl">{subtitle}</p>}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </div>
    </div>
  );
}
